/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation VendorAccountAttachFallbackRoutePlanMutation($vendorAccountId: ID!, $routePlanId: [ID!]!) {
  VendorAccountAttachFallbackRoutePlan(routePlanId: $routePlanId, vendorAccountId: $vendorAccountId) {
    id
    displayName
    message
    status
  }
}
`
